function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _g, _defs;
var _excluded = ["decorative", "title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBancontact(props) {
  var _props = props,
    decorative = _props.decorative,
    title = _props.title,
    titleId = _props.titleId,
    desc = _props.desc,
    descId = _props.descId,
    filteredProps = _objectWithoutProperties(_props, _excluded);
  props = _objectSpread(_objectSpread({}, filteredProps), {}, {
    focusable: false
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bancontact_svg__bancontact_svg__clip0_20887_3804)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 23,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    stroke: "#D9D9D9",
    rx: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.77 13.023c-1.785 2.37-3.939 5.023-8.035 5.023H4.77a1 1 0 01-1-1v-5.023a1 1 0 011-1h12C18.553 8.653 20.71 6 24.803 6h4.966a1 1 0 011 1v5.023a1 1 0 01-1 1h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bancontact_svg__bancontact_svg__paint0_linear_20887_3804)",
    d: "M9.735 17.046c3.767 0 5.65-2.512 7.534-5.023H4.77v5.023h4.966z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bancontact_svg__bancontact_svg__paint1_linear_20887_3804)",
    d: "M24.803 7c-3.767 0-5.65 2.511-7.534 5.023h12.5V7h-4.966z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bancontact_svg__bancontact_svg__paint0_linear_20887_3804",
    x1: 7.3,
    x2: 16.44,
    y1: 14.77,
    y2: 11.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005AB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E3764"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bancontact_svg__bancontact_svg__paint1_linear_20887_3804",
    x1: 18.03,
    x2: 27.74,
    y1: 12.46,
    y2: 9.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBA900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD800"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bancontact_svg__bancontact_svg__clip0_20887_3804"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h34v24H0z"
  })))));
}
export default SvgBancontact;